// extracted by mini-css-extract-plugin
export default {"summary":"ad-modal_summary__5KzhZ"};